/* eslint-disable import/prefer-default-export */
import { orgArtistInviteAcceptUrl } from '../urls';
import refresh from '../refresh';

export async function postOrgArtistInviteAccept(token) {
  const data = {
    token,
  };
  return refresh(async () => {
    const response = await fetch(orgArtistInviteAcceptUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}
